import get from 'lodash/get';
import { SCOPE } from './types';

// eslint-disable-next-line import/prefer-default-export
export const getAdminState = state => get(state, SCOPE);
